import apiClient, { setAuthToken, setUserInfo, getUserInfo } from './apiClient';
import { userService } from './userService';


export {handleLogin} from './apiClient' ;

export const authService = {
  async login(credentials) {
    const response = await apiClient.post('/api/auth/login', credentials);
    setAuthToken(response.token);
    setUserInfo(response.user);
    return response;
  },

  async logout() {
    setAuthToken(null);
    setUserInfo(null);
    // Дополнительно можно вызвать logout endpoint
    await apiClient.post('/api/auth/logout');
  },

  async register(userData) {
    const response = await apiClient.post('/api/auth/register', userData);
    setAuthToken(response.token);
    return response;
  },

  async changeRole(data) {
    const response = await apiClient.post('/auth/change_role', data);
    const { privilegedUser, token } = response.data || {};
    if(!privilegedUser) return false;

    const userInfo = getUserInfo();
    userInfo.privilegedUser = privilegedUser;
    setAuthToken(token);
    setUserInfo(userInfo);

    const firstPage = userService.firstPage();

    return firstPage;
  },

  async returnToMainRole(privelegedRole) {
    const response = await apiClient.post('auth/change_role',{ role: "kindergartenHead", area: "main", mode: "return"});

    const { privilegedUser, token } = response.data || {};
    if(!privilegedUser) return false;

    const userInfo = getUserInfo();
    userInfo.privilegedUser = privilegedUser;
    setAuthToken(token);
    setUserInfo(userInfo);
    
    const firstPage = userService.firstPage();

    return firstPage;
  }

};






